module.exports = __webpack_public_path__ + "static/media/img_uaic.171feaf7.svg";